import motorcycleSvg from "./icons/motorcycle.svg";
import hotelIcon from "./icons/hotel-svgrepo-com.svg";
import shopIcon from "./icons/shop-2-svgrepo-com.svg";
import warehouseIcon from "./icons/warehouse-svgrepo-com.svg";
import officeIcon from "./icons/office-svgrepo-com.svg";
import factoryIcon from "./icons/industrial-factory-svgrepo-com.svg";

const svg = (body, fill) =>
  `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="${fill}" d="${body}"/></svg>`;

const light = "#ffffff";

export const MARKER_ICON_SVGS = {
  "explorer-person": svg(
    "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
    light,
  ),
  "explorer-house": svg("M12 3 3 11h2v9h5v-6h4v6h5v-9h2z", light),
  "explorer-passenger": svg(
    "M18.9 6c-.2-.6-.8-1-1.4-1h-11c-.6 0-1.2.4-1.4 1L3 12v8c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-1h12v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-8zm-12.4 10c-.8 0-1.5-.7-1.5-1.5S5.7 13 6.5 13s1.5.7 1.5 1.5S7.3 16 6.5 16zm11 0c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11z",
    light,
  ),
  "explorer-motorcycle": motorcycleSvg,
  "explorer-van": svg(
    "M3 7h11v8H3zm11 2h4l3 4v2h-7zM7 18a2 2 0 1 0 .01 0zM17 18a2 2 0 1 0 .01 0z",
    light,
  ),
  "explorer-truck": svg(
    "M2 7h11v9H2zm11 2h4l4 4v3h-8zM6 19a2 2 0 1 0 .01 0zM16 19a2 2 0 1 0 .01 0z",
    light,
  ),
  "explorer-hotel": hotelIcon,
  "explorer-retail": shopIcon,
  "explorer-warehouse": warehouseIcon,
  "explorer-office": officeIcon,
  "explorer-industrial": factoryIcon,
  "explorer-accident": svg(
    "M12 2.5 1.5 21h21L12 2.5zm0 5.2 1.05 6.3h-2.1L12 7.7zM12 16.2a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5z",
    light,
  ),
};

const PROPERTY_ICONS = {
  residential: "explorer-house",
  hotel: "explorer-hotel",
  retail: "explorer-retail",
  warehouse: "explorer-warehouse",
  office: "explorer-office",
  industrial: "explorer-industrial",
};

export const markerIconId = (entity, layer) => {
  if (layer === "broker") return "explorer-person";
  if (layer === "property") {
    return PROPERTY_ICONS[entity.property_type] || "explorer-house";
  }
  if (layer === "motor") return MARKER_ICON_SVGS[`explorer-${entity.vehicle_type}`]
    ? `explorer-${entity.vehicle_type}`
    : "explorer-passenger";
  return "";
};

const pendingIcons = new Set();

export const addMarkerIcons = (map) => {
  Object.entries(MARKER_ICON_SVGS).forEach(([id, markup]) => {
    if (map.hasImage(id) || pendingIcons.has(id)) return;
    pendingIcons.add(id);
    const image = new Image();
    image.onload = () => {
      pendingIcons.delete(id);
      if (map.hasImage(id)) return;
      const size = 64;
      const canvas = document.createElement("canvas");
      canvas.width = size;
      canvas.height = size;
      const context = canvas.getContext("2d");
      context.drawImage(image, 0, 0, size, size);
      const imageData = context.getImageData(0, 0, size, size);
      if (!markup.startsWith("<")) {
        const pixels = imageData.data;
        for (let index = 0; index < pixels.length; index += 4) {
          const ink = pixels[index] + pixels[index + 1] + pixels[index + 2];
          if (pixels[index + 3] < 16 || ink < 40) {
            pixels[index + 3] = 0;
            continue;
          }
          pixels[index] = 255;
          pixels[index + 1] = 255;
          pixels[index + 2] = 255;
        }
      }
      if (!map.hasImage(id)) {
        map.addImage(id, imageData, { pixelRatio: 2 });
      }
    };
    image.onerror = () => pendingIcons.delete(id);
    image.src = markup.startsWith("<")
      ? `data:image/svg+xml;charset=utf-8,${encodeURIComponent(markup)}`
      : markup;
  });
};
